module.exports = __webpack_public_path__ + "static/img/feature_1.2cc1829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/feature_1.png
// module id = kTH+
// module chunks = 0